module.exports = __webpack_public_path__ + "img/20wjhz-txt.1a5c6c3e.svg";